import { render, staticRenderFns } from "./selectTree.vue?vue&type=template&id=124bc9d5&scoped=true&"
import script from "./selectTree.vue?vue&type=script&lang=js&"
export * from "./selectTree.vue?vue&type=script&lang=js&"
import style0 from "./selectTree.vue?vue&type=style&index=0&id=124bc9d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124bc9d5",
  null
  
)

export default component.exports